import Button from '../ui/Button'

export default function BulkActionBar({ kind, count, onSelectAll, onClear, onExit, onMarkDone, onArchive, onDelete }) {
    if (count === 0) return null
    return (
        <div className="fixed bottom-24 left-1/2 -translate-x-1/2 z-40 bg-white dark:bg-zinc-950 text-black dark:text-white border-2 border-black dark:border-white shadow-brutal-lg px-4 py-3 flex flex-wrap items-center gap-3">
            <span className="text-sm font-semibold">{count} selected</span>
            <button onClick={onSelectAll} className="text-sm underline underline-offset-2 hover:text-accent">Select all</button>
            <button onClick={onClear} className="text-sm underline underline-offset-2 hover:text-accent">Clear</button>
            <div className="flex items-center gap-2 ml-2">
                {kind === 'task' && (
                    <Button variant="secondary" className="text-xs px-2 py-1" onClick={onMarkDone}>Mark Done</Button>
                )}
                {kind === 'note' && (
                    <Button variant="secondary" className="text-xs px-2 py-1" onClick={onArchive}>Archive</Button>
                )}
                <Button variant="destructive" className="text-xs px-2 py-1" onClick={onDelete}>Delete</Button>
            </div>
            <button onClick={onExit} aria-label="Exit select mode" className="ml-2 text-lg leading-none hover:text-accent">×</button>
        </div>
    )
}
